// File: src/components/car/FAQ.jsx
// NOTE: All classes prefixed with "car-faq-" to avoid conflict with FinanceFAQ.css
import React, { useState } from 'react';
import './FAQ.css';

const faqs = [
  {
    question: "What services do you provide after buying the car?",
    answer: "At CarYugo, we provide end-to-end support including RC transfer assistance, documentation guidance, and post-sale customer support to ensure a smooth ownership experience."
  },
  {
    question: "What is the process for booking a car?",
    answer: "You can book a car by clicking on 'Book Now', completing the booking request, and our team will contact you to confirm availability, schedule a test drive, or proceed with the purchase."
  },
  {
    question: "Can I schedule a test drive before buying?",
    answer: "Yes, you can easily schedule a test drive at your convenience. We offer flexible test drive options in cities like Indore, Bhopal, Ujjain, Dewas, Mhow, and Pithampur."
  },
  {
    question: "How do you ensure the quality of listed cars?",
    answer: "Each car goes through a thorough inspection process and seller verification. We provide transparent and accurate information so buyers can make fully informed decisions."
  },
  {
    question: "Can I sell my car on CarYugo?",
    answer: "Yes! You can list your car by providing details and booking an inspection. Our platform helps connect you with genuine buyers and simplifies the entire selling process."
  },
  {
    question: "Do you provide assistance with RC transfer?",
    answer: "Yes, we assist with RC transfer and all necessary documentation to make ownership transfer smooth and completely hassle-free."
  },
  {
    question: "Is there any return policy available?",
    answer: "We focus on helping buyers make the right decision through thorough inspections and test drives. Return policies may vary depending on the deal and will be clearly communicated during purchase."
  },
  {
    question: "In which cities are your services available?",
    answer: "CarYugo currently operates in Indore, Bhopal, Ujjain, Dewas, Mhow, and Pithampur, with plans to expand to more cities soon."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <div className="car-faq-section">
      <h3 className="car-faq-heading">Frequently Asked Questions</h3>
      <div className="car-faq-list">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return (
            <div
              key={index}
              className={`car-faq-item${isOpen ? ' car-faq-item--open' : ''}`}
            >
              {/* Using a div+onClick instead of button to avoid FinanceFAQ.css button overrides */}
              <div
                className="car-faq-trigger"
                onClick={() => toggle(index)}
                role="button"
                tabIndex={0}
                aria-expanded={isOpen}
                onKeyDown={(e) => e.key === 'Enter' || e.key === ' ' ? toggle(index) : null}
              >
                <span className="car-faq-question-text">{faq.question}</span>
                <span className="car-faq-icon" aria-hidden="true">
                  {isOpen ? '−' : '+'}
                </span>
              </div>

              {isOpen && (
                <div className="car-faq-answer">
                  <p className="car-faq-answer-text">{faq.answer}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FAQ;